<template>
  <!-- 采用左右布局 -->
  <el-container class="ht100">
    <!-- 左侧侧边栏 -->
    <el-aside :style="subNavDynamicStyle">
      <div class="subNav_Title">
        <h3>全媒体</h3>
      </div>
      <!-- 侧边导航栏选项 -->
      <el-menu style="border-right: none;" :default-active="$route.path" router>
        <el-menu-item v-for="(r)  in routeData" :key="r.path" :index="r.path">
          <span slot="title">{{ $t(r.name) }}</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <!-- 导航栏收缩小按钮 -->
    <div class="icon-sub-shrink" :style="iconDynamicStyle" @click="clickIconSubShrink()">
      <svg class="icon" aria-hidden="true" :style="iconRotateDynamicStyle">
        <use xlink:href="#iconretract-arrow" />
      </svg>
    </div>

    <!-- 右侧主体面板:通过动态路由加载 -->
    <el-main class="main-noscroll">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      // 动态路由
      routeData: [],
      msg: '系统管理',
      // 导航栏收缩涉及的动态样式
      shrinkSubNav: true,
      subNavDynamicStyle: {
        width: '170px',
        height: '100%',
        display: 'block',
        background: '#f7f8fa',
        'border-right': '1px solid #e1e3e6'
      },
      iconDynamicStyle: { left: '149px' },
      iconRotateDynamicStyle: { transform: 'rotate(0deg)' }
    }
  },
  mounted: function () {
    // 获取子菜单权限
    this.routeData = this.$authUtis.getModuleMenu('/channel')

    this.routeData.filter(item => item.show !== 'false')
  },
  methods: {
    // 收缩或展开侧边导航栏
    clickIconSubShrink() {
      if (this.shrinkSubNav) {
        this.subNavDynamicStyle = { display: 'none' }
        this.iconDynamicStyle = { left: '0px' }
        this.iconRotateDynamicStyle = { transform: 'rotate(180deg)' }
        this.shrinkSubNav = false
      } else {
        this.subNavDynamicStyle = {
          width: '170px',
          height: '100%',
          display: 'block',
          background: '#f7f8fa',
          'border-right': '1px solid #e1e3e6'
        }
        this.iconDynamicStyle = { left: '149px' }
        this.iconRotateDynamicStyle = { transform: 'rotate(0deg)' }
        this.shrinkSubNav = true
      }
    }
  }
}
</script>

<style scoped>
.subNav_Title {
  position: relative;
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  border-bottom: 1px solid #e1e3e6;
  color: #222222;
  border-bottom: 1px solid #e1e3e6;
}
.main-noscroll {
  /*overflow: hidden;*/
}
</style>
